import React from 'react';
import styled from 'styled-components';

const SVG = styled.svg`
	width: 20px;
	height: 20px;

	.cls-3 {
		fill: #c1c5c8;
	}
	#boundary {
		fill: transparent;
	}
	#chevron-down-shadow-2 {
		fill: ${props => props.theme.boxShadow};
		opacity: 0.65;
	}
	#style-1 {
		filter: url(#chevron-down-shadow);
	}
	#style-2 {
		filter: url(#chevron-down-highlight);
	}
	#style-3 {
		filter: url(#chevron-down-highlight-2);
	}

	@media screen and (min-width: ${props => props.theme.res.medium}) and (max-width: ${props =>
			props.theme.res.high}) {
	}

	@media screen and (min-width: ${props => props.theme.res.high}) {
	}
`;

export const DownArrowSVG = ({ className, id }) => {
	return (
		<SVG width='152' height='152' viewBox='0 0 152 152' id={id} className={className}>
			<defs>
				<filter
					id='chevron-down-shadow'
					x='18'
					y='42'
					width='128'
					height='84.5'
					filterUnits='userSpaceOnUse'
				>
					<feOffset dx='6' dy='6' />
					<feGaussianBlur stdDeviation='4' result='blur' />
					<feFlood flood-color='#323e48' />
					<feComposite operator='in' in2='blur' />
					<feComposite in='SourceGraphic' />
				</filter>
				<filter
					id='chevron-down-highlight'
					x='16.5'
					y='32.5'
					width='119'
					height='76'
					filterUnits='userSpaceOnUse'
				>
					<feOffset dy='-8' />
					<feGaussianBlur stdDeviation='2.5' result='blur-2' />
					<feFlood flood-color='#fff' />
					<feComposite operator='in' in2='blur-2' />
					<feComposite in='SourceGraphic' />
				</filter>
				<filter
					id='chevron-down-highlight-2'
					x='18'
					y='42'
					width='110'
					height='66.5'
					filterUnits='userSpaceOnUse'
				>
					<feOffset dx='-3' dy='-3' />
					<feGaussianBlur stdDeviation='1' result='blur-3' />
					<feFlood flood-color='#fff' />
					<feComposite operator='in' in2='blur-3' />
					<feComposite in='SourceGraphic' />
				</filter>
			</defs>
			<g id='chevron-down-primary' transform='translate(299 -3184)'>
				<path id='boundary' transform='translate(-299 3184)' d='M0 0h152v152H0z' />
				<g id='chevron-down-primary-2' data-name='chevron-down-primary'>
					<g id='style-1' transform='translate(-299 3184)'>
						<path
							id='chevron-down-shadow-2'
							data-name='chevron-down-shadow'
							d='m112 5.724-52 36.5-52-36.5v24l52 36.5 52-36.5z'
							transform='translate(16 42.28)'
						/>
					</g>
					<g id='style-2' transform='translate(-299 3184)'>
						<path
							id='chevron-down-highlight-3'
							data-name='chevron-down-highlight'
							class='cls-3'
							d='m112 5.724-52 36.5-52-36.5v24l52 36.5 52-36.5z'
							transform='translate(16 42.28)'
						/>
					</g>
					<g id='style-3' transform='translate(-299 3184)'>
						<path
							id='chevron-down-highlight-4'
							data-name='chevron-down-highlight'
							class='cls-3'
							d='m112 5.724-52 36.5-52-36.5v24l52 36.5 52-35.97z'
							transform='translate(16 42.28)'
						/>
					</g>
				</g>
			</g>
		</SVG>
	);
};
